import { render, staticRenderFns } from "./ad-route-link.vue?vue&type=template&id=457c3196&scoped=true&"
import script from "./ad-route-link.vue?vue&type=script&lang=js&"
export * from "./ad-route-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c3196",
  null
  
)

export default component.exports